export default __webpack_public_path__ + "static/media/croc@2x.85ac3ba3.png";